import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "../styles/MembershipPayment.css";
import {
  loadRazorpayScript,
  createMembershipOrder,
  openRazorpayCheckout,
  verifyMembershipPayment,
  formatIndianCurrency
} from "../utils/razorpay";

const MembershipPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const baseUrl = process.env.REACT_APP_BASEURL;
const [paymentCompleted, setPaymentCompleted] = useState(false); // ✅ ADDED
// Add this with your other state declarations
const [paymentLoading, setPaymentLoading] = useState(false); // 🔴 CHANGE: Add payment loading state
  const membershipData = location.state?.membershipData;
  const membershipType = location.state?.membershipType;

  useEffect(() => {
    if (!membershipData || !membershipType) {
      navigate('/');
    }
  }, [membershipData, membershipType, navigate]);

  const calculatePaymentBreakdown = () => {
    const baseAmount = Number(membershipData?.amount_IN) || 0;
    const gstAmount = Math.round((baseAmount * 18) / 118); // Since amount includes GST
    const subtotal = baseAmount - gstAmount;

    return {
      subtotal,
      gstAmount,
      totalAmount: baseAmount
    };
  };

  const handleProceedToPayment = async () => {
    try {
      await loadRazorpayScript();
      setLoading(true);
      setError(null);
 setPaymentLoading(true);
      const breakdown = calculatePaymentBreakdown();

      const orderResp = await createMembershipOrder({
        baseUrl,
        amountInRupees: breakdown.totalAmount,
        membershipType: membershipType,
        memberId: membershipData._id,
        notes: {
          breakdown: JSON.stringify(breakdown)
        }
      });

      await openRazorpayCheckout({
        order: orderResp.order,
        name: "AIOTA - Membership Registration",
        memberId: membershipData._id,
        memberType: membershipType === "full" ? "lifememberships" : "associatememberships",
        description: `${membershipType === 'full' ? 'Life' : 'Associate'} Membership Registration`,
        prefill: {
          name: membershipData.name || "",
          email: membershipData.email || "",
          contact: `${membershipData.countryCode || "+91"}${membershipData.phone}` || ""
        },
        notes: {
          membership_type: membershipType,
          email: membershipData.email || "N/A",
          contact: `${membershipData.countryCode || "+91"}${membershipData.phone}` || ""
        },
        onSuccess: async (response) => {
          try {
            console.log("Payment successful, verifying payment...");
               setPaymentCompleted(true);
          setPaymentLoading(true); // Keep button disabled
          
            const verifyResp = await verifyMembershipPayment({
              baseUrl,
              payload: {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount_paise: breakdown.totalAmount * 100,
                amount_rupees: breakdown.totalAmount
              },
              membershipType,
              memberId: membershipData._id
            });

            console.log("Payment verification response:", verifyResp);

            if (verifyResp?.success) {

              localStorage.removeItem("membershipFormData");
setPaymentCompleted(true); // ✅ ADDED

              setLoading(false); // ✅ CHANGED

              navigate('/payment-success', {
                state: {
                  membershipType,
                  paymentDetails: {
                    orderId: response.razorpay_order_id,
                    paymentId: response.razorpay_payment_id,
                    amount: breakdown.totalAmount * 100, // Convert to paise for consistency
                    amountInRupees: breakdown.totalAmount
                  },
                  membershipData: {
                    name: membershipData.name,
                    email: membershipData.email,
                    phone: membershipData.phone
                  },
                  loginCredentials: {
                    email: membershipData.email,
                    // Password will be sent via email, not displayed here for security
                    message: "Your login credentials have been sent to your email address."
                  }
                }
              });
            } else {
               setPaymentCompleted(false);
            setPaymentLoading(false);
            setLoading(false);
              throw new Error("Payment verification failed");
            }
          } catch (err) {
            console.error("Payment verification error:", err);
            setError("Payment verification failed. Please contact support with your payment details.");
            setPaymentCompleted(false);
          setPaymentLoading(false);
          setLoading(false);
          }
        },
        onFailure: (err) => {
          console.error("Payment failed:", err);
           setPaymentCompleted(false);
        setPaymentLoading(false);
        setLoading(false);
        setError(err?.message || "Payment was not completed.");
        }
      });
    } catch (err) {
      console.error("Payment initialization error:", err);
     setPaymentCompleted(false);
    setPaymentLoading(false);
    setLoading(false);
    setError("Unable to initiate payment. Please try again later.");
    }
    // ❌ REMOVED finally block (was causing redirect delay)
  };

  const handleBack = () => {
    // Retrieve form data from localStorage
    const savedFormData = localStorage.getItem("membershipFormData");
    const formData = savedFormData ? JSON.parse(savedFormData) : {};

    navigate('/stepper-form', {
      state: {
        membershipData: membershipData,
        membershipType: membershipType,
        formData: formData // Pass the saved form data back to the form
      }
    });
  };

  const breakdown = calculatePaymentBreakdown();

  return (
    <div className="membership-payment-page">
      <section className="hero-fixed">
        <div className="hero-content">
          <h1>Membership Payment</h1>
        </div>
      </section>

      <div className="scrollable-content">
        <div className="content-container">
          <div className="payment-content">
            <div className="payment-header">
              <h2>{membershipType === 'full' ? 'Life' : 'Associate'} Membership Registration Payment</h2>
            </div>

            <div className="payment-details">
              <div className="member-info">
                <div className="info-row">
                  <span className="label">Name:</span>
                  <span className="value">{membershipData?.name}</span>
                </div>
                <div className="info-row">
                  <span className="label">Email:</span>
                  <span className="value">{membershipData?.email}</span>
                </div>
                <div className="info-row">
                  <span className="label">Phone:</span>
                  <span className="value">{membershipData?.phone}</span>
                </div>
              </div>

              <div className="payment-breakdown">
                <h3>Payment Breakdown</h3>
                <div className="breakdown-table">
                  <div className="breakdown-row">
                    <span className="label">Registration Fee:</span>
                    <span className="value">{formatIndianCurrency(breakdown.subtotal)}</span>
                  </div>
                  <div className="breakdown-row">
                    <span className="label">GST (18%):</span>
                    <span className="value">{formatIndianCurrency(breakdown.gstAmount)}</span>
                  </div>
                  <div className="breakdown-row total">
                    <span className="label">Total Amount:</span>
                    <span className="value">{formatIndianCurrency(breakdown.totalAmount)}</span>
                  </div>
                </div>
              </div>

              <div className="payment-notes">
                <div className="note warning">
                  <h4>Important Notes:</h4>
                  <ul>
                    <li>The membership fee includes 18% GST</li>
                    <li>Once registered, the membership fee is non-refundable</li>
                    <li>In case of technical errors or network issues during payment, the amount will be automatically refunded by Razorpay</li>
                    <li>Please ensure stable internet connection before proceeding with the payment</li>
                  </ul>
                </div>
              </div>
{error && (
  <div className="error-message alert alert-danger">
    <div className="d-flex align-items-start">
      <i className="fas fa-exclamation-triangle me-2 mt-1"></i>
      <div className="w-100">
        <h6 className="mb-2 fw-bold">Payment Error</h6>
        <p className="mb-2">{error}</p>
        <p className="mb-0 small text-danger">
          If this issue persists, please contact support with your membership details.
        </p>
      </div>
    </div>
  </div>
)}
<div className="payment-actions-member flex-sm-row flex-column">
  <button
    className="payment-button-member btn w-auto"
    onClick={handleProceedToPayment}
    disabled={loading || paymentLoading || paymentCompleted}
  >
    {paymentLoading ? (
      <>
        <span
          className="spinner-border me-2"
          role="status"
          aria-hidden="true"
          style={{ width: "1rem", height: "1rem", borderWidth: "2px" }}
        ></span>
        {paymentCompleted ? "Payment Completed" : "Processing..."}
      </>
    ) : paymentCompleted ? (
      "Payment Completed"
    ) : (
      "Proceed to Payment"
    )}
  </button>
</div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipPayment;
